import { SET_REPORT_SETTINGS, CLEAR_REPORT_FILTERS } from './analytics-actions';


//
// Initial AuthReducer State
const initialEmptyState = {
  isShi: true,
  selectedCrop: '',
  selectedIndicatorKey: '',
  selectedIndicator: null,
  grouping: 'id',
  unit: '',
  sort: 'default'
};

const emptyFilters = {
  treatments: [],
  field: [],
  farm: [],
  startDate: '',
  endDate: '',
  id: [],
  includeNext: true,
  plantedCrop: []
}

const initialState = {
  ...initialEmptyState,
  sampleFilters: emptyFilters,
  setInitial: false
}

// Auth Reducer
function analyticsReducer(state = {...initialState}, action) {
  switch(action.type) {
    case SET_REPORT_SETTINGS: {
      //maintain previous sampleFilters
      if (action.settings.sampleFilters){
        action.settings.sampleFilters = {...state.sampleFilters, ...action.settings.sampleFilters};
      }
      //update in local store
      localStorage.setItem(`reportSettings-${sessionStorage.getItem('userId')}`, JSON.stringify({...state.sampleFilters,...action.settings.sampleFilters}))
      let unit = ''
      if (!!action.selectedIndicator){
        unit = action.selectedIndicator['display_unit']
        ? action.selectedIndicator['display_unit']
        : unit = action.selectedIndicator.key ==='aerobic_to_anaerobic_ratio' ? '' : 'PPB soil'
      } else {
        unit = action.settings.selectedIndicatorKey ==='aerobic_to_anaerobic_ratio' ? '' : 'PPB soil'
      }
      return {
        ...state,
        ...action.settings,
        unit: unit,
        selectedIndicator: action.selectedIndicator
      };
    }
    case CLEAR_REPORT_FILTERS: {
      const clearFilters = {
        treatments: [],
        field: [],
        farm: [],
        startDate: '',
        endDate: '',
        id: [],
        includeNext: true,
        plantedCrop: [],
      };
      //update in local store
      localStorage.setItem(`reportSettings-${sessionStorage.getItem('userId')}`, JSON.stringify(clearFilters))
      return {...state, sampleFilters: clearFilters};
    }
    default: {
      return state;
    }
  }
}

export default analyticsReducer;
